(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-boarding-passes"] && !Shopify.designMode) return;
  try {
    
  // Wallet effect: turn the reader's scroll through the runway into a
  // position from 1 to n+1. The ticket at that position slides up into
  // place; the ones before it stay tucked behind, showing their top half.
  if (!customElements.get('ska-passes-wallet')) {
    customElements.define('ska-passes-wallet', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.pin = this.querySelector('.ska-passes__pin');
        this.list = this.querySelector('.ska-wallet');
        this.cards = [...this.querySelectorAll('.ska-ticket')];
        if (!this.pin || !this.list || this.cards.length < 2) return;
        this.onScroll = () => this.update();
        this.onResize = () => this.fit();
        // Capture scroll events from any element: on wide screens Horizon
        // scrolls .page-wrapper, not the window.
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onResize);
        // Ticket heights change when fonts load or text wraps differently.
        this.observer = new ResizeObserver(() => this.fit());
        this.cards.forEach((c) => this.observer.observe(c.firstElementChild));
        this.fit();
      }
      disconnectedCallback() {
        if (!this.onScroll) return;
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        this.observer.disconnect();
      }
      reset() {
        this.classList.remove('is-wallet');
        this.list.style.removeProperty('height');
        this.cards.forEach((c) => {
          c.style.removeProperty('transform');
          c.style.removeProperty('opacity');
          c.lastElementChild.style.removeProperty('--shade');
        });
      }
      // Lay the tickets out, and only keep the effect when the finished
      // stack fits on the screen below the header; otherwise the bottom
      // would be out of reach, so the tickets sit one under the other.
      fit() {
        this.reset();
        // Measure with the effect on: short screens use tighter tickets.
        this.classList.add('is-wallet');
        this.tops = this.cards.map((c) => c.firstElementChild.offsetHeight);
        this.stub = this.cards[0].lastElementChild.offsetHeight;
        // The tallest moment is the end: every top half plus one whole ticket.
        this.list.style.height = `${this.tops.reduce((a, b) => a + b, 0) + this.stub}px`;
        const kids = [...this.pin.children].map((el) => el.getBoundingClientRect());
        const pad = parseFloat(getComputedStyle(this.pin).paddingTop) + parseFloat(getComputedStyle(this.pin).paddingBottom);
        const needed = Math.max(...kids.map((b) => b.bottom)) - Math.min(...kids.map((b) => b.top)) + pad;
        if (needed > window.innerHeight - this.headerOffset()) this.reset();
        else this.update();
      }
      // The pin sticks below the header, not at the top of the screen.
      headerOffset() {
        return parseFloat(getComputedStyle(this.pin).top) || 0;
      }
      update() {
        if (!this.classList.contains('is-wallet')) return;
        const clamp = (v) => Math.min(1, Math.max(0, v));
        const ease = (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2);
        const n = this.cards.length;
        const box = this.getBoundingClientRect();
        const travel = box.height - this.pin.offsetHeight;
        // 0 when the pin first sticks, 1 when it lets go.
        const progress = travel > 0 ? clamp((this.headerOffset() - box.top) / travel) : 1;
        const s = 1 + progress * n;
        let y = 0;
        this.cards.forEach((c, i) => {
          const t = i === 0 ? 1 : ease(clamp(s - i));
          const tucked = i === n - 1 ? 0 : ease(clamp(s - (i + 1)));
          c.style.transform = `translateY(${(y + (1 - t) * 260).toFixed(1)}px) scale(${(1 - tucked * 0.03).toFixed(4)})`;
          c.style.opacity = Math.min(1, t * 2.5).toFixed(3);
          c.lastElementChild.style.setProperty('--shade', (tucked * 0.25).toFixed(3));
          y += this.tops[i];
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setUp = () => {
      const form = document.querySelector('.ska-contact__form');
      if (!form) return;
      const boxes = [...form.querySelectorAll('[data-ska-enquiry]')];
      const all = form.querySelector('[data-ska-enquiry-all]');
      if (!boxes.length || !all) return;
      // The ticked choices travel as one "Speaking, Training" value in the
      // hidden field, so the boxes themselves are not sent.
      boxes.forEach((b) => b.removeAttribute('name'));
      const sync = () => {
        const picked = boxes.filter((b) => b.checked).map((b) => b.value);
        all.value = picked.join(', ');
        all.disabled = picked.length === 0;
      };
      const tick = (values) => {
        const wanted = values.map((v) => v.trim().toLowerCase());
        boxes.forEach((b) => { if (wanted.includes(b.value.toLowerCase())) b.checked = true; });
      };
      // Choices restored into the hidden field (after Shopify's spam check)
      // come back as ticked tiles.
      if (all.value) tick(all.value.split(','));
      // A link like /pages/contact?enquiry=Speaking arrives with that tile ticked.
      const fromLink = new URLSearchParams(window.location.search).get('enquiry');
      if (fromLink) tick([fromLink]);
      boxes.forEach((b) => b.addEventListener('change', sync));
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setUp);
    else setUp();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-lamp-hero"] && !Shopify.designMode) return;
  try {
    
  // Tie the light to scrolling: it closes as the hero scrolls away and opens
  // again on the way back. Listens in the capture phase because on wide
  // screens Horizon scrolls .page-wrapper, not the window.
  if (!customElements.get('ska-lamp')) {
    customElements.define('ska-lamp', class extends HTMLElement {
      connectedCallback() {
        this.light = this.querySelector('.ska-lamp__light');
        if (!this.light) return;
        this.hangOverBook();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.onScroll = () => {
          const box = this.getBoundingClientRect();
          const gone = Math.min(1, Math.max(0, -box.top / (box.height * 0.6)));
          this.light.style.setProperty('--ska-lamp-open', (1 - gone).toFixed(3));
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }
      // On wide screens the book sits in its own column, and where that column
      // lands depends on the screen size, so measure the book and hang the
      // light just above its centre instead of trusting a fixed percentage.
      // Offsets rather than getBoundingClientRect, so the book's rise-in
      // animation does not move the light.
      hangOverBook() {
        const book = this.querySelector('.ska-book3d');
        this.place = () => {
          const wide = window.matchMedia('(min-width: 990px)').matches;
          let x = 0, y = 0, el = book;
          while (el && el !== this) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
          if (!wide || !book || !book.offsetWidth || el !== this) {
            this.style.removeProperty('--ska-light-x');
            this.style.removeProperty('--ska-light-top');
            return;
          }
          this.style.setProperty('--ska-light-x', `${Math.round(x + book.offsetWidth / 2)}px`);
          this.style.setProperty('--ska-light-top', `${Math.max(16, Math.round(y - 60))}px`);
        };
        this.observer = new ResizeObserver(this.place);
        this.observer.observe(this);
        if (book) this.observer.observe(book);
        this.place();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }
    });
  }

  // Tilt the book with the pointer. A custom element, so it survives the
  // theme editor re-rendering the section.
  if (!customElements.get('ska-tilt')) {
    customElements.define('ska-tilt', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!window.matchMedia('(hover: hover)').matches) return;
        this.area = this.closest('[data-ska-lamp]') || this;
        this.inner = this.querySelector('.ska-book3d__inner');
        this.onMove = (event) => {
          const box = this.getBoundingClientRect();
          const x = (event.clientX - (box.left + box.width / 2)) / window.innerWidth;
          const y = (event.clientY - (box.top + box.height / 2)) / window.innerHeight;
          this.inner.style.setProperty('--ry', `${-22 + x * 30}deg`);
          this.inner.style.setProperty('--rx', `${4 - y * 14}deg`);
        };
        this.onLeave = () => {
          this.inner.style.removeProperty('--ry');
          this.inner.style.removeProperty('--rx');
        };
        this.area.addEventListener('pointermove', this.onMove);
        this.area.addEventListener('pointerleave', this.onLeave);
      }
      disconnectedCallback() {
        this.area?.removeEventListener('pointermove', this.onMove);
        this.area?.removeEventListener('pointerleave', this.onLeave);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const main = document.querySelector('main') || document.body;
    const sections = [...main.querySelectorAll('.shopify-section')]
      .filter((s, i) => i > 0 && !s.querySelector('[data-ska-reveal], [data-ska-sticky]'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    sections.forEach((s) => {
      // Anything already on screen at load stays visible, no flash.
      if (s.getBoundingClientRect().top < window.innerHeight) return;
      s.classList.add('ska-reveal-item');
      io.observe(s);
    });
    document.documentElement.classList.add('ska-reveal-ready');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  // A custom element, so it sets itself up and cleans up whenever the theme
  // editor re-renders the section.
  if (!customElements.get('ska-sticky-buy')) {
    customElements.define('ska-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.hidden = false;
        this.buyVisible = false;
        this.onScroll = () => this.update();
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // Hide the bar while the page's own buy buttons are on screen, so the
        // visitor never sees two sets of buttons at once.
        const onPage = document.querySelectorAll('product-form-component, .product-form-buttons, form[action$="/cart/add"]:not(.ska-sticky__form)');
        if ('IntersectionObserver' in window && onPage.length) {
          const seen = new Set();
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
            this.buyVisible = seen.size > 0;
            this.update();
          });
          onPage.forEach((el) => this.io.observe(el));
        }

        // Carry over anything the customer typed into the page's own form for
        // this same product, such as a dedication for a signed copy. Only
        // forms for this product count, and form.elements also includes
        // fields linked to the form from elsewhere with the form attribute.
        this.form = this.querySelector('form');
        this.onSubmit = () => {
          this.form.querySelectorAll('[data-ska-copied]').forEach((el) => el.remove());
          const sources = [...document.querySelectorAll(`product-form-component[data-product-id="${this.dataset.productId}"] form`)];
          sources.flatMap((f) => [...f.elements]).forEach((field) => {
            if (!field.name || !field.name.startsWith('properties[')) return;
            if (!field.value || ((field.type === 'checkbox' || field.type === 'radio') && !field.checked)) return;
            const copy = document.createElement('input');
            copy.type = 'hidden';
            copy.name = field.name;
            copy.value = field.value;
            copy.dataset.skaCopied = '';
            this.form.append(copy);
          });
        };
        this.form?.addEventListener('submit', this.onSubmit);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.io?.disconnect();
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      update() {
        this.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8 && !this.buyVisible);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-story-timeline"] && !Shopify.designMode) return;
  try {
    
  // Fill the line with light as the reader moves through the story.
  if (!customElements.get('ska-timeline')) {
    customElements.define('ska-timeline', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.style.setProperty('--ska-tl-progress', '0');
        // Browsers already deliver scroll events at most once per frame, and
        // this is one measurement, so no extra throttling (an animation-frame
        // throttle could freeze the line if a frame was skipped).
        this.onScroll = () => {
          const box = this.getBoundingClientRect();
          const reading = window.innerHeight * 0.6;
          const progress = Math.min(1, Math.max(0, (reading - box.top) / box.height));
          this.style.setProperty('--ska-tl-progress', progress.toFixed(3));
        };
        // Capture scroll events from any element: on wide screens Horizon
        // scrolls .page-wrapper, not the window, and element scroll events
        // do not bubble up to window.
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ska-testimonial-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ska-reel')) {
    customElements.define('ska-reel', class extends HTMLElement {
      connectedCallback() {
        this.count = Number(this.dataset.count) || 0;
        this.items = [...this.querySelectorAll('.ska-reel__item')];
        this.cols = [...this.querySelectorAll('.ska-reel__col')];
        if (!this.count || this.items.length !== this.count) return;
        this.index = 0;
        this.busy = false;
        this.loop = this.hasAttribute('data-loop') && this.count > 1;
        this.timers = [];
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onClick = (e) => {
          const btn = e.target.closest('[data-dir]');
          if (btn) this.go(Number(btn.dataset.dir));
        };
        this.onKey = (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);

        // Swipe: a mostly-horizontal drag of 40px or more moves one step.
        this.onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          // A mouse drag over the quote is text selection, not a swipe, so
          // mouse swipes only count on the decorative tile area. Touch and
          // pen swipes work anywhere on the reel.
          if (e.pointerType === 'mouse' && !e.target.closest('.ska-reel__stage')) { this.start = null; return; }
          this.swiped = false;
          this.start = { x: e.clientX, y: e.clientY, id: e.pointerId };
        };
        this.onUp = (e) => {
          const s = this.start;
          this.start = null;
          if (!s || s.id !== e.pointerId) return;
          const dx = e.clientX - s.x;
          const dy = e.clientY - s.y;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            // Swallow only the click that the browser fires straight after
            // this swipe, never a later one (a keyboard press, for example).
            this.swiped = true;
            clearTimeout(this.swipeTimer);
            this.swipeTimer = setTimeout(() => { this.swiped = false; }, 80);
            this.go(dx < 0 ? 1 : -1);
          }
        };
        this.onCancel = () => { this.start = null; };
        // A swipe that ends on a button must not also count as a click.
        this.onClickCapture = (e) => {
          if (this.swiped) { e.stopPropagation(); e.preventDefault(); this.swiped = false; }
        };
        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', this.onCancel);
        this.addEventListener('click', this.onClickCapture, true);

        this.items.forEach((item, i) => item.classList.toggle('is-active', i === 0));
        // Show one quote at a time straight away; only the sliding waits for
        // the first paint.
        this.classList.add('is-enhanced');
        this.place();
        this.updateButtons();
        // Turn transitions on after the first paint, so the reel starts in
        // place instead of sliding in.
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('pointerdown', this.onDown);
        this.removeEventListener('pointerup', this.onUp);
        this.removeEventListener('pointercancel', this.onCancel);
        this.removeEventListener('click', this.onClickCapture, true);
        (this.timers || []).forEach(clearTimeout);
        clearTimeout(this.swipeTimer);
      }

      place() {
        const style = getComputedStyle(this);
        const cell = parseFloat(style.getPropertyValue('--reel-cell')) || 110;
        const gap = parseFloat(style.getPropertyValue('--reel-gap')) || 8;
        const step = 3 * (cell + gap);
        const middle = ((this.count - 1) / 2 - this.index) * step;
        this.cols.forEach((col) => {
          col.style.transform = `translateY(${col.dataset.col === 'middle' ? middle : -middle}px)`;
        });
      }

      updateButtons() {
        this.querySelectorAll('[data-dir]').forEach((btn) => {
          const next = this.index + Number(btn.dataset.dir);
          btn.disabled = !this.loop && (next < 0 || next >= this.count);
        });
      }

      split(item) {
        // Wrap each letter in a span with a staggered delay; words stay
        // together so lines still wrap naturally.
        let n = 0;
        item.querySelectorAll('.ska-reel__quote, .ska-reel__author').forEach((el) => {
          const text = el.dataset.text ?? el.textContent;
          el.dataset.text = text;
          el.setAttribute('aria-label', text);
          el.textContent = '';
          text.split(' ').forEach((word, wi, words) => {
            const w = document.createElement('span');
            w.style.display = 'inline-block';
            w.style.whiteSpace = 'nowrap';
            w.setAttribute('aria-hidden', 'true');
            for (const ch of word) {
              const c = document.createElement('span');
              c.className = 'ska-reel__char';
              c.textContent = ch;
              c.style.animationDelay = `${n++ * 6}ms`;
              w.append(c);
            }
            el.append(w);
            if (wi < words.length - 1) { el.append(' '); n++; }
          });
          n += 6;
        });
      }

      go(dir) {
        let next = this.index + dir;
        // Looping: past the last goes to the first, and back again.
        if (this.loop) next = (next + this.count) % this.count;
        if (this.busy || next < 0 || next >= this.count || next === this.index) return;
        this.busy = true;
        const old = this.items[this.index];
        this.index = next;
        this.place();
        this.updateButtons();
        const show = () => {
          old.classList.remove('is-active', 'is-exiting');
          const item = this.items[next];
          if (!this.reduced) this.split(item);
          item.classList.add('is-active');
        };
        if (this.reduced) show();
        else { old.classList.add('is-exiting'); this.timers.push(setTimeout(show, 240)); }
        this.timers.push(setTimeout(() => { this.busy = false; }, this.reduced ? 0 : 800));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
